export default __webpack_public_path__ + "assets/images/4d978ace48cee5f8292527ee5bf165a7.webp";